import React, { useEffect } from 'react';
import './switch.css';

import { FaMoon } from 'react-icons/fa';
import { BsFillSunFill } from 'react-icons/bs';

const Switch = () => {
    useEffect(() => {
        const btnSwitch = document.querySelector('#switch');
        btnSwitch.addEventListener('click', () => {
            let mode = localStorage.getItem('mode');
            if (mode === 'light' || mode === null) {
                localStorage.setItem('mode', 'dark');
            } else if (mode === 'dark') {
                localStorage.setItem('mode', 'light');
            }
            let body = document.querySelector('body');
            body.classList.toggle('dark');
            btnSwitch.classList.toggle('active');
        });
    });

    return (
        <div>
            <button className="switch" id="switch">
                <span>
                    <BsFillSunFill className="icon-lg" />
                </span>
                <span>
                    <FaMoon />
                </span>
            </button>
        </div>
    );
};

export default Switch;
